import {
  NavIconEight,
  NavIconFive,
  NavIconFour,
  NavIconNine,
  NavIconOne,
  NavIconSeven,
  NavIconSix,
  NavIconTen,
  NavIconThree,
  NavIconTwo,
} from "../constant/imagePath";

export const NAV_DATA = [
  {
    id: 1,
    label: "Dashboard",
    icon: NavIconOne,
    submenu: [
      { label: "Dashboard", route: "/" },
      // { label: "Analytics", route: "/analytics" },
    ],
  },
  {
    id: 2,
    label: "Merchant",
    icon: NavIconTwo,
    submenu: [{ label: "Approve Merchant", route: "/merchant" }],
  },
  {
    id: 2,
    label: "Visual",
    icon: NavIconTwo,
    submenu: [{ label: "Approve Visual", route: "/auction-visual-request" }],
  },
  {
    id: 3,
    label: "Lots",
    icon: NavIconThree,
    submenu: [{ label: "Approve Lots", route: "/lots" }],
  },
  {
    id: 4,
    label: "Auction",
    icon: NavIconFour,
    submenu: [{ label: "Approve Auction", route: "/auction" }],
  },

  {
    id: 5,
    label: "Logistics",
    icon: NavIconFive,
    submenu: [{ label: "Logistics", route: "#!" }],
    // submenu: [
    //   { label: "Profile", route: "/profile" },
    //   { label: "Logout", route: "/logout" },
    // ],
  },
  {
    id: 6,
    label: "Invoicing",
    icon: NavIconSix,
    submenu: [{ label: "Invoicing", route: "#!" }],
  },
  {
    id: 7,
    label: "Finance",
    icon: NavIconSeven,
    submenu: [{ label: "Finance Management", route: "#!" }],
  },
  {
    id: 8,
    label: "System",
    icon: NavIconEight,
    submenu: [{ label: "System Configurations", route: "#!" }],
  },
  {
    id: 9,
    label: "Consignments",
    icon: NavIconNine,
    submenu: [{ label: "Consignments", route: "#!" }],
  },
  {
    id: 10,
    label: "Inbox",
    icon: NavIconTen,
    submenu: [{ label: "Inbox", route: "#!" }],
  },
];

export const DASHBOARD_TABLE_HEADER_ALL = [
  { title: "User id", key: "_id", style: { width: "20%" } },
  { title: "User Name", key: "fullName", style: { width: "20%" } },
  { title: "Email", key: "email", style: { width: "30%" } },
  { title: "Status", key: "isBlockedByAdmin", style: { width: "20%" } },
  { title: "", key: "", style: { width: "10%" } },
];
export var recordsLimit = 10;
